// Small markdown renderer for the AI chat replies. Everything is HTML-escaped first, so only the
// tags produced here reach v-html: paragraphs, headings, bold/italic, inline and block code,
// bullet/numbered lists, simple tables and http(s) links.

function escapeHtml(text) {
    return text
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
}

function inline(text) {
    return text
        .replace(/`([^`]+)`/g, '<code>$1</code>')
        .replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
        .replace(/(^|[^*\w])\*([^*\n]+)\*(?!\w)/g, '$1<em>$2</em>')
        .replace(/(^|[^_\w])_([^_\n]+)_(?!\w)/g, '$1<em>$2</em>')
        .replace(/\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g, '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>')
}

function tableRow(line) {
    return line.replace(/^\s*\|/, '').replace(/\|\s*$/, '').split('|').map(cell => inline(cell.trim()))
}

export function renderMarkdown(source) {
    const lines = escapeHtml(String(source || '')).replace(/\r\n/g, '\n').split('\n')
    const out = []
    let i = 0

    while (i < lines.length) {
        const line = lines[i]

        if (/^```/.test(line)) {
            const code = []
            i++
            while (i < lines.length && !/^```/.test(lines[i])) code.push(lines[i++])
            i++
            out.push(`<pre><code>${code.join('\n')}</code></pre>`)
            continue
        }

        const heading = line.match(/^(#{1,4})\s+(.*)$/)
        if (heading) {
            const level = Math.min(heading[1].length + 3, 6) // keep headings small inside the bubble
            out.push(`<h${level}>${inline(heading[2])}</h${level}>`)
            i++
            continue
        }

        if (/^\s*\|.*\|\s*$/.test(line) && i + 1 < lines.length && /^\s*\|?\s*:?-{2,}/.test(lines[i + 1])) {
            const head = tableRow(line)
            i += 2
            const rows = []
            while (i < lines.length && /^\s*\|.*\|\s*$/.test(lines[i])) rows.push(tableRow(lines[i++]))
            out.push('<div class="md-table"><table><thead><tr>' + head.map(c => `<th>${c}</th>`).join('') + '</tr></thead><tbody>'
                + rows.map(r => '<tr>' + r.map(c => `<td>${c}</td>`).join('') + '</tr>').join('') + '</tbody></table></div>')
            continue
        }

        if (/^\s*[-*•]\s+/.test(line) || /^\s*\d+[.)]\s+/.test(line)) {
            const ordered = /^\s*\d+[.)]\s+/.test(line)
            const items = []
            while (i < lines.length && (ordered ? /^\s*\d+[.)]\s+/ : /^\s*[-*•]\s+/).test(lines[i])) {
                items.push(inline(lines[i].replace(ordered ? /^\s*\d+[.)]\s+/ : /^\s*[-*•]\s+/, '')))
                i++
            }
            const tag = ordered ? 'ol' : 'ul'
            out.push(`<${tag}>` + items.map(item => `<li>${item}</li>`).join('') + `</${tag}>`)
            continue
        }

        if (line.trim() === '') {
            i++
            continue
        }

        // The first line always belongs to the paragraph (e.g. a "|" line that turned out not to be a table)
        const paragraph = [inline(lines[i++])]
        while (i < lines.length && lines[i].trim() !== '' && !/^```|^#{1,4}\s|^\s*[-*•]\s+|^\s*\d+[.)]\s+|^\s*\|.*\|\s*$/.test(lines[i])) {
            paragraph.push(inline(lines[i++]))
        }
        out.push(`<p>${paragraph.join('<br>')}</p>`)
    }

    return out.join('')
}
